import { BOM } from './BOM.js';

var _isIOS = function() {
    return navigator && navigator.userAgent && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

function indexOf(arr, refer) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === refer) {
            return i;
        }
    }
    return -1;
}

const bridge = (function() {
    var callbacks = [],
        callbackID = 0,
        registerHandlers = [];
    document.addEventListener(
        'PacificDidReceiveNativeCallback',
        function(e) {
            if (e.detail) {
                var detail = e.detail;
                var id = isNaN(parseInt(detail.id)) ? -1 : parseInt(detail.id);
                if (id != -1) {
                    callbacks[id] && callbacks[id](detail.parameters, detail.error);
                    delete callbacks[id];
                }
            }
        },
        false
    );
    document.addEventListener(
        'PacificDidReceiveNativeBroadcast',
        function(e) {
            if (e.detail) {
                var detail = e.detail;
                var name = detail.name;
                if (name !== undefined && registerHandlers[name]) {
                    var namedListeners = registerHandlers[name];
                    if (namedListeners instanceof Array) {
                        var parameters = detail.parameters;
                        // 使用压缩的话， 这句话压缩不过
                        // (handler) => { handler(parameters) }
                        namedListeners.forEach(function(handler) {
                            handler(parameters);
                        });
                    }
                }
            }
        },
        false
    );
    return {
        post: function(action, parameters, callback, print) {
            var message = { action: action, parameters: parameters, print: print || 0 };
            if (callback) {
                var id = ++callbackID;
                callbacks[id] = callback;
                message['callback'] = id;
            }
            // For iOS
            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.pacific
            ) {
                window.webkit.messageHandlers.pacific.postMessage(message);
            } else {
                // For Android
                if (window.pacific && window.pacific.didReceiveMessage) {
                    window.pacific.didReceiveMessage(JSON.stringify(message));
                } else {
                    // For Apps Havn't Implement (Message Bridge)
                    var openURLString =
                        'pacific://postMessage?_json=' +
                        encodeURIComponent(JSON.stringify(message));
                    var bridgeFrame = document.createElement('iframe');
                    bridgeFrame.setAttribute('src', openURLString);
                    document.documentElement.appendChild(bridgeFrame);
                    bridgeFrame.parentNode.removeChild(bridgeFrame);
                    bridgeFrame = null;
                }
            }
        },
        on: function(name, callback) {
            var namedListeners = registerHandlers[name];
            if (!namedListeners) {
                registerHandlers[name] = namedListeners = [];
            }
            namedListeners.push(callback);
            return function() {
                namedListeners[indexOf(namedListeners, callback)] = null;
            };
        },
        off: function(name) {
            delete registerHandlers[name];
        },
        open_url: function(url) {
            if (_isIOS()) {
                bridge.post('open_url', { url: url });
            } else {
                if (typeof BOM.window.androidObj != 'undefined') {
                    BOM.window.androidObj.call(url);
                } else {
                    alert('no androidobject');
                }
            }
        }
    };
})();
export { bridge };
